import { CSSProperties, ReactNode } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { Color } from '@vivli/shared/theme';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const containerStyle = (): CSSProperties => ({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: '5px',
    alignItems: 'center',
});

///note: this is specifically for cells that need to show Yes or No
export const GridCellYesNoView = ({ value }: ICellRendererParams): ReactNode => {
    const _value = value ? 'Yes' : 'No';
    return (
        <div style={containerStyle()}>
            <div>{_value}</div>
        </div>
    );
};
